var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('p',{staticClass:"footer-text"},[_vm._v("Copyright © "+_vm._s(_vm.currentYear)+" Inventech")])])
}
var staticRenderFns = []

export { render, staticRenderFns }